import Tooltip from './Tooltip.jsx';
import './StatusBadge.css';

const STATUS_STYLES = {
  Approved: { className: 'customer-portal-status-badge--approved', icon: 'check' },
  Completed: { className: 'customer-portal-status-badge--approved', icon: 'check' },
  Delivered: { className: 'customer-portal-status-badge--approved', icon: 'check' },
  Draft: { className: 'customer-portal-status-badge--draft', icon: null },
  Submitted: { className: 'customer-portal-status-badge--submitted', icon: null },
  Processing: { className: 'customer-portal-status-badge--submitted', icon: null },
  'In Transit': { className: 'customer-portal-status-badge--transit', icon: null },
  Placed: { className: 'customer-portal-status-badge--transit', icon: null },
  Pending: { className: 'customer-portal-status-badge--pending', icon: null },
  Hold: { className: 'customer-portal-status-badge--hold', icon: null },
  Parked: { className: 'customer-portal-status-badge--parked', icon: null },
  Backordered: { className: 'customer-portal-status-badge--backordered', icon: null },
  Rejected: { className: 'customer-portal-status-badge--rejected', icon: 'x' },
  Cancelled: { className: 'customer-portal-status-badge--cancelled', icon: 'x' },
};

function Icon({ type }) {
  if (type === 'check') {
    return (
      <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
        <polyline points="20 6 9 17 4 12" />
      </svg>
    );
  }
  if (type === 'x') {
    return (
      <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    );
  }
  return null;
}

export default function StatusBadge({ status }) {
  const style = STATUS_STYLES[status] ?? { className: 'customer-portal-status-badge--draft', icon: null };
  return (
    <Tooltip as="span" className={`customer-portal-status-badge ${style.className}`} content={status}>
      {style.icon && <Icon type={style.icon} />}
      {status}
    </Tooltip>
  );
}